import { Component, inject, input } from '@angular/core';
import { PlatformService } from '~app/services/platform.service';

@Component({
  selector: 'app-card',
  templateUrl: './card.html',
  styleUrl: './card.css',
})
export class Card {
  readonly title = input<string>();
  readonly subtitle = input<string>();
  readonly image = input<string>();
  readonly errorSubtitle = input<string>();
  readonly loading = input<boolean>();

  protected readonly platform = inject(PlatformService);
}
